import Form, { generateForm } from './Form';
import Templates, { generateTemplates } from './templates';
import Theme, { generateTheme } from './Theme';
import Widgets, { generateWidgets } from './widgets';

export { Form, Templates, Theme, Widgets, generateForm, generateTemplates, generateTheme, generateWidgets };

export default Form;
